/**
 * Utility functions for CartMembershipsService.
 *
 * Mirrors: apps/b2b-ui/common/services/cart/memberships/memberships.utils.ts
 */

import { MembershipLifecycleActionForm } from '@b2b/types/membership';

interface CartMembershipItem {
  membershipInfo?: {
    membershipCategoryId?: string;
    membershipCategoryName?: string;
    membershipOfferingName?: string;
  };
}

/**
 * Resolves the membership name for a lifecycle form by looking it up in the cart memberships.
 */
export function resolveMembershipNameForForm(
  lifecycleForm: MembershipLifecycleActionForm,
  cartMemberships: CartMembershipItem[],
): string {
  const membershipLevelsInfo = lifecycleForm.membershipLevelsInfo ?? [];

  for (const levelInfo of membershipLevelsInfo) {
    const formMembershipLevelId = levelInfo?.membershipLevel?.id;
    if (!formMembershipLevelId) continue;

    const matchingMembership = cartMemberships.find(
      (item) => item.membershipInfo?.membershipCategoryId === formMembershipLevelId,
    );

    if (matchingMembership?.membershipInfo?.membershipCategoryName) {
      const { membershipCategoryName, membershipOfferingName } = matchingMembership.membershipInfo;
      return membershipOfferingName ? `${membershipCategoryName} - ${membershipOfferingName}` : membershipCategoryName;
    }
  }

  return membershipLevelsInfo[0]?.membershipLevel?.name ?? '';
}
